<script setup lang="ts">
import FilterDropdown from '~/components/mobile/common/filter-dropdown-v2.vue'
import { ModalCollection } from '~/constants'
import type { DropdownItem } from '~/composables/common/interface'

defineProps<{
  label?: string
  placeholder?: string
  valueSelected?: string
  optionItems: DropdownItem[]
  withButton?:{ action: () => void; title: string }
}>()

const emits = defineEmits(['handleItemSelected'])
</script>

<template>
  <FilterDropdown
    :label="label ?? 'Ngân hàng'"
    iconTypeImage
    :placeholder="placeholder ?? 'Chọn ngân hàng'"
    :modalId="ModalCollection.SELECT_BANK"
    :valueSelected="valueSelected"
    :optionItems="optionItems"
    :withButton="withButton"
    @handleItemSelected="item => emits('handleItemSelected', item)"
  />
</template>

<style scoped lang="scss">
:deep(.filter-dropdown__header) {
  position: relative;
  z-index: 1;
  gap: 12px;

  img {
    width: 16px;
    height: 16px;
  }

  &:not(:has(.not-selected)) {
    padding-left: 16px;

    &::before {
      content: '';
      position: absolute;
      top: 8px;
      left: 12px;
      z-index: -1;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background-color: $neutral-100;
    }
  }
}
</style>
